import React, { useCallback } from "react";
import {
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  Cell,
} from "recharts";
import moment from "moment";

const SpaceUtilizationChart = ({ data, title, datakey, conditions }) => {
  const fillBar = useCallback(
    (value) => {
      if (
        value >= conditions["Good"]["Min"] &&
        value <= conditions["Good"]["Max"]
      ) {
        return "lawngreen";
      }
      else if (
        value > conditions["Moderate"]["Min"] &&
        value < conditions["Moderate"]["Max"]
      ) {
        return "#ffff00";
      }
      else if (
        value >= conditions["Poor"]["Min"] ||
        value <= conditions["Poor"]["Max"]
      ) {
        return "#f00";
      }
      else return "";
    },
    [conditions]
  );

  return (
    <>
    {data && data.length&&  <ResponsiveContainer className="mt-4" minHeight={"100%"}>
        <BarChart
          data={data}
          height="100%"
          width="100%"
          margin={{ bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="8 8" />
          <XAxis
            dataKey="enqueuedTime_Stamp"
            tickFormatter={(unixTime) => moment(unixTime).format("HH:mm Do")}
            tick={{
              stroke: "#f3f3f3",
              fill: "#f3f3f3",
              strokeWidth: 0.5,
            }}
          />
          <YAxis
            tick={{
              stroke: "#f3f3f3",
              fill: "#f3f3f3",
              strokeWidth: 0.5,
            }}
          />
          <Tooltip
            wrapperClassName="navbar-bg"
            labelFormatter={(value) => {
              return `label: ${moment(value).format("HH:mm Do")}`;
            }}
          />
          <Legend
            verticalAlign="top"
            payload={[
              {
                value: title,
                type: "line",
                id: "ID01",
                color: "#c9e9f4",
              },
            ]}
          />
          <Bar dataKey={datakey} stroke="#c9e9f4" fill="#c9e9f4">
            {data?.map((entity, index) => {
              let color = fillBar(entity[datakey]);
              return <Cell fill={color} stroke={color}/>;
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>}
    
    </>
  );
};

export default SpaceUtilizationChart;
